import { Link } from "react-router-dom";
import RightDocSidebar from "../../components/RightSidebar";

/* Individual report components (empty for now) */
import EventReport from "../../components/Report Module/EventReport";
import ServiceReport from "../../components/Report Module/ServiceReport";
import ExpenseReport from "../../components/Report Module/ExpenseReport";
import WaitersReport from "../../components/Report Module/WaitersReport";
import SoundSystemReport from "../../components/Report Module/SoundSystemReport";
import DocNavigation from "../../components/DocNavigation";

export default function Reports() {
    const reportSections = [
        {
            title: "1. Event Report",
            expandable: false,
            items: [{ id: "event-report", label: "Event Report" }],
        },
        {
            title: "2. Service Report",
            expandable: false,
            items: [{ id: "service-report", label: "Service Report" }],
        },
        {
            title: "3. Expense Report",
            expandable: false,
            items: [{ id: "expense-report", label: "Expense Report" }],
        },
        {
            title: "4. Waiters Report",
            expandable: false,
            items: [{ id: "waiters-report", label: "Waiters Report" }],
        },
        {
            title: "5. Sound System Report",
            expandable: false,
            items: [{ id: "sound-system-report", label: "Sound System Report" }],
        },
    ];

    return (
        <div className="flex gap-12">

            {/* MAIN CONTENT */}
            <div className="flex-1 space-y-16">

                {/* HERO — SAME FORMAT AS ALL PAGES */}
                <section className="bg-white rounded-xl border border-slate-200 p-10">
                    <h1 className="text-2xl font-bold text-slate-900 mb-4">
                        Reports Module
                    </h1>
                    <p className="text-md text-slate-600 max-w-3xl">
                        The Reports module provides detailed insights into bookings,
                        services, expenses, and operational performance — enabling
                        data-driven decision making.
                    </p>
                </section>

                {/* REPORT SECTIONS */}
                <EventReport />
                <ServiceReport />
                <ExpenseReport />
                <WaitersReport />
                <SoundSystemReport />

                {/* NEXT */}
                {/* <section className="border-t pt-8 mt-12">
                    <p className="text-slate-600">
                        Next, explore the{" "}
                        <Link to="/docs/banquet-setup" className="font-medium text-[#C9A24E]">
                            Banquet Setup Module
                        </Link>.
                    </p>
                </section> */}
                  <DocNavigation
                    previous={{
                        title: "Event Booking Management",
                        link: "/docs/event-booking-management"
                    }}
                    next={{
                        title: "Banquet Setup Module",
                        link: "/docs/banquet-setup"
                    }}
                />
            </div>

            {/* RIGHT SIDEBAR */}
            <RightDocSidebar groups={reportSections} />
        </div>
    );
}
